// extracted by mini-css-extract-plugin
export default {"full-width":"Home_full-width__v47Uq","calc-width":"Home_calc-width__C9GbH"};